import React, {useEffect, useState} from 'react'
import {StickyContainer, Sticky} from 'react-sticky'
import {withTheme} from 'styled-components'
import {GlobalNotificationService} from 'services'
import {getLang} from 'utils/stringUtils'

import NotificationBar from 'components/notifications/NotificationBar'
import {useNotificationsContext} from 'context/NotificationsContext'

const getCurrentNotification = (notifications, landing) => {
  const landingPageNotification = notifications.find(({isOnlyLandingpage}) => isOnlyLandingpage)
  const globalNotification = notifications.find(({isOnlyLandingpage}) => !isOnlyLandingpage)
  if (landing && landingPageNotification) {
    return landingPageNotification
  }
  if (globalNotification) {
    return globalNotification
  }
  return null
}

const getNotificationMessage = ({messages}) => {
  const lang = getLang(window.location.search) || 'de'
  const textsByLang = messages.reduce((texts, message) => {
    texts[message.language] = message.text
    return texts
  }, {})

  return textsByLang[lang] || textsByLang.en || ''
}

const Notifications = ({theme}) => {
  const [globalNotification, setGlobalNotification] = useState(null)
  const {notifications, hideNotification, config} = useNotificationsContext()

  const hideGlobalNotification = () => {
    setGlobalNotification(null)
  }

  const getGlobalNotifications = async () => {
    try {
      const notifications = await GlobalNotificationService.getEnabledNotifications()
      const currentNotification = getCurrentNotification(notifications, config.landing)

      if (currentNotification) {
        setGlobalNotification({
          type: currentNotification.type,
          message: getNotificationMessage(currentNotification),
          isDismissible: currentNotification.isDismissable,
        })
      }
    } catch {}
  }

  useEffect(() => {
    getGlobalNotifications()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.landing])

  const boundaryPositions = config.sticky
    ? {top: theme.shell.header.height.onScroll}
    : {
        top: 0,
        left: 0,
        right: 0,
      }

  return (
    <StickyContainer
      style={{
        position: config.sticky ? 'sticky' : 'fixed',
        zIndex: config.sticky ? 1 : 2,
        ...boundaryPositions,
      }}>
      <Sticky relative disableCompensation disableHardwareAcceleration>
        {() => (
          <div>
            {notifications.map(notification => (
              <NotificationBar
                key={notification.id}
                {...notification}
                hideNotification={hideNotification(notification.id)}
              />
            ))}
            {globalNotification && (
              <NotificationBar {...globalNotification} hideNotification={hideGlobalNotification} />
            )}
          </div>
        )}
      </Sticky>
    </StickyContainer>
  )
}

export default withTheme(Notifications)
